import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoadingMaskComponent } from "./loadingmask.component";
import { LoadingMaskConfig, LoadingMaskConfigToken } from "./loadingmask.config.model";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ResourceModule } from "../../feature/core/resource/resource.module";

@NgModule({
    imports: [CommonModule, ResourceModule, MatProgressSpinnerModule],
    declarations: [LoadingMaskComponent],
    exports: [LoadingMaskComponent]
})
class LoadingMaskModule {}

export {
    LoadingMaskModule,
    LoadingMaskComponent,
    LoadingMaskConfigToken,
    LoadingMaskConfig
};
